import { useMemo, useState } from 'react';
import {
  Activity,
  Boxes,
  Bot,
  FileJson,
  Gauge,
  Home,
  Library,
  LogIn,
  Network,
  PlusCircle,
  Workflow
} from 'lucide-react';
import { DashboardPage } from '../routes/DashboardPage';
import { ScoresPage } from '../routes/ScoresPage';
import { CreateScorePage } from '../routes/CreateScorePage';
import { AgentLibraryPage } from '../routes/AgentLibraryPage';
import { ToolLibraryPage } from '../routes/ToolLibraryPage';
import { WorkflowPage } from '../routes/WorkflowPage';
import { RankingPage } from '../routes/RankingPage';
import { McpDocsPage } from '../routes/McpDocsPage';
import { LoginPage } from '../routes/LoginPage';
import { LandingPage } from '../routes/LandingPage';

const routes = [
  { id: 'landing', label: 'Home', icon: Home, component: LandingPage },
  { id: 'dashboard', label: 'Dashboard', icon: Gauge, component: DashboardPage },
  { id: 'scores', label: 'Scores', icon: Activity, component: ScoresPage },
  { id: 'create', label: 'Create Score', icon: PlusCircle, component: CreateScorePage },
  { id: 'agents', label: 'Agents', icon: Bot, component: AgentLibraryPage },
  { id: 'tools', label: 'Connectors', icon: Boxes, component: ToolLibraryPage },
  { id: 'workflows', label: 'Workflows', icon: Workflow, component: WorkflowPage },
  { id: 'rankings', label: 'Rankings', icon: Library, component: RankingPage },
  { id: 'mcp', label: 'MCP Docs', icon: Network, component: McpDocsPage },
  { id: 'login', label: 'Login', icon: LogIn, component: LoginPage }
] as const;

export function App() {
  const [activeRoute, setActiveRoute] = useState<(typeof routes)[number]['id']>('landing');
  const ActiveComponent = useMemo(
    () => routes.find((route) => route.id === activeRoute)?.component ?? LandingPage,
    [activeRoute]
  );

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand">
          <FileJson size={28} aria-hidden="true" />
          <div>
            <strong>Orchestration Score</strong>
            <span>Agent setup ranking</span>
          </div>
        </div>
        <nav aria-label="Primary">
          {routes.map((route) => {
            const Icon = route.icon;
            return (
              <button
                key={route.id}
                className={activeRoute === route.id ? 'nav-item active' : 'nav-item'}
                type="button"
                onClick={() => setActiveRoute(route.id)}
              >
                <Icon size={18} aria-hidden="true" />
                <span>{route.label}</span>
              </button>
            );
          })}
        </nav>
      </aside>
      <main className="main-panel">
        <ActiveComponent />
      </main>
    </div>
  );
}
